import ko from "knockout";
import template from "./index.html";

const viewModel = function({click, name, icon}) {
    this.click = click;
    this.attr = {
        class: 'social-logo-' + name,
    };
    this.style = {};
    if (icon) {
        this.style.backgroundImage = `url(${icon})`;
    }
};

ko.components.register('social-login-icon', {
    viewModel,
    template,
});
